import {yupResolver} from '@hookform/resolvers/yup'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {Column} from 'react-table'
import {FormProvider, useForm} from 'react-hook-form'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {InputTextArea} from '../../../../../../../../components/UI/Input'
import {Select} from '../../../../../../../../components/UI/Select'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../../../../util/functions'
import {schemaOrderLaundryBatchObs} from '../../../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {InfoLaundryBatchDetail, LaundryBatchModel, TypeClothe} from '../../../../../../model'
import {
  createLaundryBatchObs,
  getOrdersWithoutObservation,
  updateLaundryBatchObs,
} from '../../../../../../services'
import {useKTable} from '../../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../../../components/UI'
import {InputTextWrapper} from '../../../../../../../../components/UI/Form/Input'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getObservationList: () => void
  setIdObservation: () => void
  idObservation?: ''
  observation?: any
}

const ModalAddObservation: FC<Props> = ({
  show,
  setShow,
  setIdObservation,
  getObservationList,
  idObservation,
  observation,
}) => {
  const {currentTabItem} = useLavanderia()
  const [typeObservations, setTypeObservations] = useState<TypeClothe[] | any>([])

  const [statusObservations, setStatusObservations] = useState<any>([])

  const [ordersWithoutObservation, setOrdersWithoutObservation] = useState<
    LaundryBatchModel[] | any
  >([])
  const [ordersWithoutObservationSelect, setOrdersWithoutObservationSelect] = useState<
    string[] | any
  >([])
  const [addOther, setAddOther] = useState<boolean>(false)

  const methods = useForm<any>({
    resolver: yupResolver(schemaOrderLaundryBatchObs),
  })
  const {
    control,
    setValue,
    handleSubmit,
    register,
    formState: {errors},
  } = methods

  const {loading, setLoading, clearSelected} = useKTable()

  const handleSelectObservation = (id: any) => {
    if (ordersWithoutObservationSelect.includes(id)) {
      setOrdersWithoutObservationSelect(
        ordersWithoutObservationSelect.filter((itemId: any) => itemId !== id),
      )
    } else {
      const updatedSelected = [...ordersWithoutObservationSelect]
      updatedSelected.push(id)
      setOrdersWithoutObservationSelect(updatedSelected)
    }
  }

  const columns: Column<InfoLaundryBatchDetail>[] = [
    // {
    //   Header: (props) => <KTableHeader tableProps={props} title='Empresa Subcontratista' />,
    //   accessor: 'empresaSubContratista',
    // },
    // {
    //   Header: (props) => <KTableHeader tableProps={props} title='Nro documento' />,
    //   accessor: 'numeroDocumento',
    // },
    // {
    //   Header: (props) => <KTableHeader tableProps={props} title='Nombre completo' />,
    //   accessor: 'nombreResponsable',
    // },
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => (
        <KTableSelectionCell
          id={props.data[props.row.index].id}
          clickHandler={handleSelectObservation}
        />
      ),
    },
    // {
    //   Header: (props) => <KTableHeader tableProps={props} title='ID' />,
    //   accessor: 'id',
    // },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Orden Lavado' />,
      accessor: 'nroOrden',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro boleta' />,
      accessor: 'nroBoleta',
    },
    // {
    //   Header: (props) => <KTableHeader tableProps={props} title='Cantidad de prendas' />,
    //   accessor: 'cantidadPrendas',
    // },
    // {
    //   Header: (props) => <KTableHeader tableProps={props} title='Peso KG' />,
    //   accessor: 'cantidadKG',
    // },
  ]

  const getTypeObservationsList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoObservacionLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
      }))
      setTypeObservations(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  const getStateObservationsList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'ESTADOOBSERVACIONORDENLOTE',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setStatusObservations(mappedMaster)
    } catch (error) {
      console.error('Error al obtener los estados de la orden:', error)
    }
  }

  const getOrdersWithoutObservationList = async () => {
    try {
      setOrdersWithoutObservation([])
      setLoading(true)
      let obj = {
        idOrdenLoteLavado: currentTabItem.typeProcess === 'LAVADO' ? currentTabItem.idToEdit : null,
        idOrdenLoteSalida: currentTabItem.typeProcess === 'SALIDA' ? currentTabItem.idToEdit : null,
        tipoLavado: currentTabItem.typeWash,
      }
      const response = await getOrdersWithoutObservation(obj, 1)
      const dataInfo = response.data?.data || []
      // const dataInfo = [{ "id": "NGLz_ugOyFUzli2k4Wx3MCAHBd4VsAbZ", "nroOrden": 25, "numeroDocumento": "20212039", "empresaSubContratista": "ANULACIONES", "nombreResponsable": "TEST TEST TEST", "nroBoleta": "3005", "cantidadPrendas": 8, "cantidadKG": 3 }]
      if (!response.data.error) {
        setOrdersWithoutObservation(dataInfo)
      }
    } catch (error) {
      console.log('ERROR: ', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (idObservation) {
      setValue('observaciones', observation?.Descripcion)
      setValue('tipoObservacion', observation?.TipoObservacion)
      setValue('estadoObservacion', observation?.estadoObservacionNombre)
    } else {
      setValue('observaciones', '')
      setValue('estadoObservacion', '')
      setValue('tipoObservacion', '')
    }
  }, [idObservation])

  useEffect(() => {
    getTypeObservationsList()
    getStateObservationsList()
  }, [])

  useEffect(() => {
    if (show) {
      clearSelected()
      setOrdersWithoutObservationSelect([])
      if (!idObservation) {
        getOrdersWithoutObservationList()
      }
    }
  }, [show])

  const handleClose = () => {
    setShow(false)
    setIdObservation()
    setValue('observaciones', '')
    setValue('estado', '')
    setValue('tipoObservacion', '')
    setOrdersWithoutObservation([])
    setOrdersWithoutObservationSelect([])
  }

  const handleContinue = () => {
    setValue('observaciones', '')
    setValue('estado', '')
    setValue('estadoObservacion', '')
    // setValue('tipoObservacion', '')}
    clearSelected()
    setOrdersWithoutObservationSelect([])
    getObservationList()
    getOrdersWithoutObservationList()
  }

  const onSubmit = async (data: any) => {
    try {
      if (idObservation) {
        const {data: res} = await updateLaundryBatchObs({
          Id: idObservation,
          OrdenLoteId: currentTabItem.idToEdit,
          TipoObservacion: data.tipoObservacion,
          Descripcion: data.observaciones,
          tipoLavado: currentTabItem.typeWash,
          estadoObservacion: data.estadoObservacion,
          OrdenIds: observation.OrdenIds,
        })
        if (!res.error) {
          ShowSnackBar('Se actualizó con exito')
          handleClose()
          getObservationList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      } else {
        setLoading(true)
        const request = {
          OrdenLoteId: currentTabItem.idToEdit,
          TipoObservacion: data.tipoObservacion,
          Descripcion: data.observaciones,
          tipoLavado: currentTabItem.typeWash,
          OrdenIds: ordersWithoutObservationSelect,
        }
        const {data: response} = await createLaundryBatchObs(request)
        if (!response.error) {
          ShowSnackBar('Se creó con exito')
        } else {
          ShowSnackBar(response.message, 'error')
        }
        setLoading(false)
        if (addOther) {
          handleContinue()
        } else {
          handleClose()
        }
        getObservationList()
      }
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {idObservation ? (
            <h5 className='modal-title'>Editar Observación</h5>
          ) : (
            <h5 className='modal-title'>Agregar Observación</h5>
          )}
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row mb-4'>
                <div className='mb-2 col-6'>
                  <label className='required'>Tipo de Observación</label>
                  <Select
                    control={control}
                    name='tipoObservacion'
                    data={typeObservations}
                    errors={errors}
                  />
                </div>
                {!idObservation && (
                  <div className='col-12'>
                    <label>Observaciones:</label>
                    {loading ? (
                      <KTableLoading title='Cargando...' />
                    ) : (
                      <KTable
                        data={ordersWithoutObservation}
                        columns={columns as any}
                        showPagination={false}
                      />
                    )}
                  </div>
                )}
                <div className='col-sm-12 col-lg-12'>
                  <label>Detalle de Observación:</label>
                  <InputTextArea
                    name='observaciones'
                    textPlaceholder='Escribe la observación'
                    register={register}
                    errors={errors}
                  />
                </div>
                {!!idObservation && (
                  <div className='col-sm-12 col-lg-6'>
                    <label className='required'>Estado de Observación</label>
                    <InputTextWrapper name='estadoObservacion' disabled={!!idObservation} />
                    {/* <Select
                      control={control}
                      name='estadoObservacion'
                      data={statusObservations}
                      errors={errors}
                    /> */}
                  </div>
                )}
                {!idObservation && (
                  <div className='col-12 mt-1'>
                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        value='1'
                        checked={addOther}
                        onChange={() => setAddOther(!addOther)}
                      />
                      <span className='form-check-label'>Registrar otra observación</span>
                    </label>
                  </div>
                )}
              </div>
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddObservation}
